import { hot } from 'react-hot-loader/root';
import { createContext } from 'react';
import { object } from 'prop-types';
import { SSR } from '../helpers/ssr';
import abTests from './split-tests';
import domains from './domain-variants';
import globalSettings from './global-settings';
export const {
  Consumer,
  Provider
} = /*#__PURE__*/createContext();
const GlobalVariablesProvider = ({
  children,
  ...props
}) => {
  const value = SSR ? {
    ...props
  } : {
    ...abTests,
    ...domains,
    ...globalSettings
  };
  return /*#__PURE__*/React.createElement(Provider, {
    value: value
  }, children);
};
GlobalVariablesProvider.propTypes = {
  children: object
};
export default hot(GlobalVariablesProvider);